import { Elements, ExpandingSection } from '@tfo/common'
import { WrappedComponentProps, injectIntl } from 'react-intl'

import './AboutBackgroundCheck.scss'


const { ListItem, UnsortedList, Paragraph } = Elements
export interface AboutBackgroundCheckProps {
	order: { companyName: string, checkpointTypes: Array<string> }
	isOngoing?: boolean
}

const supremeCourtCheckpoint = ["SupremeCourt"];

const checkpointSortOrder: Record<string, number> = {
  DistrictCourts: 1,
  CourtsOfAppeal: 2,
  AdministrativeCourts: 3,
	SupremeCourt: 4,
};

const AboutBackgroundCheck = ({
	order,
	intl,
	isOngoing
}: AboutBackgroundCheckProps & WrappedComponentProps) => {
	const extendedCheckpointTypes = [
		...supremeCourtCheckpoint,
		...(order.checkpointTypes || [])
	];

	const sortedCheckpointTypes = extendedCheckpointTypes
		.map(type => ({
			type,
			sortOrder: checkpointSortOrder[type] ?? 999
		}))
		.sort((a, b) => a.sortOrder - b.sortOrder)
		.map(item => item.type);

	return !sortedCheckpointTypes.length 
	? null
	: (
		<ExpandingSection
			caption={intl.formatMessage({
				id: 'aboutBackgroundCheck.expandingCaption',
			})}
			className="AboutBackgroundCheck">
			<Paragraph>
				{intl.formatMessage(
					{ id: 'aboutbackgroundcheck.header' },
					{ companyName: order.companyName },
				)}
			</Paragraph>
			<UnsortedList>
				{sortedCheckpointTypes.map((checkpointType, index) => (
					<ListItem key={index}>{intl.formatMessage({ id: `service.checkpoints.${checkpointType}` })}</ListItem>
				))}
			</UnsortedList>

			{!isOngoing &&
				<>
					<Paragraph bold className='before-proceeding-header'>
						{intl.formatMessage({
							id: 'aboutbackgroundcheck.beforeProceeding.header',
						})}
					</Paragraph>

					<UnsortedList className='before-proceedings'>
						<ListItem className='before-proceeding-list-item'>
							<Paragraph>
								{intl.formatMessage(
									{ id: 'aboutbackgroundcheck.beforeProceeding.1' },
									{
										companyName: order.companyName,
									},
								)}
							</Paragraph>
						</ListItem>
						<ListItem className='before-proceeding-list-item'>
							<Paragraph>
								{intl.formatMessage(
									{ id: 'aboutbackgroundcheck.beforeProceeding.2' },
									{
										companyName: order.companyName,
									},
								)}
							</Paragraph>
						</ListItem>
						<ListItem className='before-proceeding-list-item'>
							<Paragraph>
								{intl.formatMessage(
									{
										id: 'aboutbackgroundcheck.beforeProceeding.3'
									})}
							</Paragraph>
						</ListItem>
						<ListItem className='before-proceeding-list-item'>
							<Paragraph>
								{intl.formatMessage(
									{id: 'aboutbackgroundcheck.beforeProceeding.6'},
									{
										companyName: order.companyName,
									},
								)}
							</Paragraph>
						</ListItem>
					</UnsortedList>
					<Paragraph className='before-proceeding-footer'>
						{intl.formatMessage(
							{
								id: 'aboutbackgroundcheck.beforeProceeding.5'
							})}
					</Paragraph>
				</>
			}
		</ExpandingSection>
	)
}

export default injectIntl(AboutBackgroundCheck)
